import { Image } from '../types';

export function fileToImage(file: File): Image {
  return {
    url: URL.createObjectURL(file),
    name: file.name,
    size: file.size,
  };
}
